import React from "react";
import {MainFooter} from "./MainFooter";
import {RootNotificationComponent} from "../notifications/RootNotificationComponent";
import type {MainComponentProps} from "./RootTypes.ts";
import {DrawerMain} from "./drawer/DrawerMain.tsx";
import {MainMenu} from "./menu/MainMenu.tsx";
import {MainHeader} from "./header/MainHeader.tsx";
import {DEFAULT_APP_STATE} from "../../stores/RootAppStore.ts";


export const MainComponent: React.FC<MainComponentProps> = (
    {state, topHeader, menu, children, centeredContent}) => {
    state = state ?? DEFAULT_APP_STATE;

    // TODO: Somehow this is preventing some initialization errors
    //  I suspect this is because of some typescript optimization issue (using TS 5.9.3)
    const _ = <MainFooter/>;

    return <DrawerMain
        className={(state?.appSection ? `section-${state.appSection}` : '') + (centeredContent ? ` centered-content` : '')}
        menu={menu ?? <MainMenu/>}
        topHeader={topHeader ?? <MainHeader state={state}/>}>
        <RootNotificationComponent/>
        {children}
    </DrawerMain>
};
